module.exports = __webpack_public_path__ + "files/be9211f8132fe3ff786eb013d65b9300.svg";